/** FOR TESTING **/

import relaunchTime from '../../../../../config/relaunchTime.json';

const d = new Date();
d.setSeconds(d.getSeconds() + 1.5);

/** FOR TESTING **/

export default function () {
	//	return d;

	const rel = relaunchTime.relaunchTime.split(' ');
	const date = rel[0].split('-');

	const time = rel[1].split(':');

	return new Date(
		Date.UTC(date[0], date[1] - 1, date[2], time[0], time[1], time[2])
	);
	//	return new Date(Date.UTC(2023, 5, 9, 18, 0, 0));
}
